export const CART_BREADCRUMB = [
  { label: "Home", url: "/" },
  { label: "Cart", url: "/cart" },
];

export const MAX_CART_ITEM_QTY = 10;
